import { render } from "./TheAdminIndex.vue?vue&type=template&id=c6c64354"
import script from "./TheAdminIndex.vue?vue&type=script&lang=js"
export * from "./TheAdminIndex.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__